export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/contact/tp',
		name: 'NbuContactTp',
		title: {
			single: 'NbuContactTp',
			plural: 'NbuContactTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "K",
				"code": null,
				"name": "Керівник",
				"caption": "Керівник",
				"isBlocked": false
			},
			{
				"id": "D",
				"code": null,
				"name": "Особа, яка має право вчиняти юридичні дії без довіреності",
				"caption": "Особа, яка має право вчиняти юридичні дії без довіреності",
				"isBlocked": false
			},
			{
				"id": "B",
				"code": null,
				"name": "Головний бухгалтер",
				"caption": "Головний бухгалтер",
				"isBlocked": false
			},
			{
				"id": "F",
				"code": null,
				"name": "Фіз. особа, на яку покладено ведення бухгалтерського обліку",
				"caption": "Фіз. особа, на яку покладено ведення бухгалтерського обліку",
				"isBlocked": false
			},
			{
				"id": "C",
				"code": null,
				"name": "Юр. особа, на яку покладено ведення бухгалтерського обліку",
				"caption": "Юр. особа, на яку покладено ведення бухгалтерського обліку",
				"isBlocked": false
			},
			{
				"id": "Q",
				"code": null,
				"name": "Кваліфікований працівник",
				"caption": "Кваліфікований працівник",
				"isBlocked": false
			},
			{
				"id": "P",
				"code": null,
				"name": "Контактна особа",
				"caption": "Контактна особа",
				"isBlocked": false
			},
			{
				"id": "M",
				"code": null,
				"name": "Керівник з реалізації",
				"caption": "Керівник з реалізації",
				"isBlocked": false
			},
			{
				"id": "S",
				"code": null,
				"name": "Керівник/керівник з реалізації",
				"caption": "Керівник/керівник з реалізації",
				"isBlocked": false
			}
		],
	},
}
